import { useEffect, useState } from "react";
import { api } from "./api";

// ENABLE_PAID_TIERS comes from the backend; defaults to false until loaded so paid tiers never flash.
let cached = null;
let inflight = null;

function load() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api.get("/api/config/features")
      .then((r) => { cached = { ENABLE_PAID_TIERS: Boolean(r.data?.ENABLE_PAID_TIERS) }; return cached; })
      .catch(() => ({ ENABLE_PAID_TIERS: false }))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState(cached || { ENABLE_PAID_TIERS: false });
  useEffect(() => {
    let alive = true;
    load().then((f) => { if (alive) setFlags(f); });
    return () => { alive = false; };
  }, []);
  return flags;
}

export const ALL_TIERS = [
  { id: "free", label: "Free", paid: false },
  { id: "basic", label: "Basic", paid: true },
  { id: "vip", label: "VIP", paid: true },
];

export function visibleTiers(flags) {
  return ALL_TIERS.filter((t) => !t.paid || flags.ENABLE_PAID_TIERS);
}
